import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { FButton } from "@/components/forkd/FButton";
import { FInput } from "@/components/forkd/FInput";
import { Wordmark } from "@/components/forkd/Wordmark";

export default function ResetPassword() {
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) {
      setErr(error.message);
      return;
    }
    nav("/home", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[var(--colour-background)] px-5 pt-16 pb-10 flex flex-col">
      <div className="flex justify-center mb-10">
        <Wordmark size={40} />
      </div>
      <h2 className="text-[20px] font-semibold text-center mb-6">Set a new password</h2>
      <form onSubmit={onSubmit} className="space-y-3">
        <FInput
          name="password"
          label="New password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={6}
          error={err}
        />
        <FButton type="submit" fullWidth loading={loading}>
          Update password
        </FButton>
      </form>
    </div>
  );
}
